export default "__VITE_ASSET__B2c_itpu__"